import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

// Pages
import HomePage from "../components/Mainpage/HomePage";
import AuthPage from "../components/Auth/AuthPage";
// import AdminDashboard from "../components/Auth/AdminDashboard";
import ProfilePage from "../components/profile/ProfilePage";
import OrderPageHistory from "../components/Mainpage/OrderPageHistory";
import WishlistPage from "../components/wishlist/WishlistPage";
import ProductDetailsPage from "../components/productDetail/ProductDetailsPage";
import CartPage from "../components/cart/cartpage";

// --- IMPORT YOUR CHECKOUT PAGE (Named PurchaseModal in your code) ---
import PurchaseModal from "../components/purchaseModal/PurchaseModal"; 
// Note: Ensure the file path above matches where you saved the code you just shared.

import { products as initialProducts } from "../components/products/ProductList";
import Categoryproducts from "../components/categoryproducts"
import SearchPage from "../components/Searchpage";

import ContactPage from "../components/contact/contact";
import UserForgotPassword from "../components/Auth/UserForgotPassword";
import LandingPage from "../pages/LandingPage";
import EducationalProductsPage from "../components/products/educational_products";
import FoodProductsPage from "../components/products/food_products";
import DeviceProductsPage from "../components/products/device_products";
import ToyProductsPage from "../components/products/toy_products";
const AppRoutes = () => {
  const { isLoggedIn, isAdmin, user, cart, wishlist, handleIncreaseQuantity, handleBuyNow, handleAddToWishlist, handleRemoveFromWishlist, setCart, setUser } = useAuth();
  
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [products] = useState(initialProducts);
  const navigate = useNavigate();

  // Filter logic
  const filteredProducts = products.filter((p) =>
    (selectedCategory === "All" || p.category === selectedCategory) &&
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Routes>
        {/* Home */}
        <Route path="/" element={<LandingPage />} />
        <Route path ='/pharmacy' element={<HomePage/>}/>
        <Route path="/education" element={<EducationalProductsPage />} />
        <Route path="/food" element={<FoodProductsPage />} />
        <Route path="/devices" element={<DeviceProductsPage />} />
        <Route path="/toys" element={<ToyProductsPage />} />
        <Route path="/category/:category" element={<Categoryproducts />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path='/contact' element={<ContactPage/>}/>
        {/* Auth */}
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/forgot-password" element={<UserForgotPassword />} />

        {/* Profile (Protected) */}
        <Route
          path="/profile"
          element={
            isLoggedIn ? (
              <ProfilePage user={user} setUser={setUser} />
            ) : (
              <Navigate to="/auth" />
            )
          }
        />

        {/* Orders (Protected) */}
        <Route
          path="/orders"
          element={isLoggedIn ? <OrderPageHistory /> : <Navigate to="/auth" />}
        />

        {/* Wishlist (Protected) */}
        <Route
          path="/wishlist"
          element={isLoggedIn ? <WishlistPage /> : <Navigate to="/auth" />}
        />

        {/* Product Details */}
        <Route 
          path="/product/:domain/:id" 
          element={
            <ProductDetailsPage 
              cart={cart}
              setCart={setCart} 
              wishlist={wishlist} 
              onAddToWishlist={handleAddToWishlist} 
              onRemoveFromWishlist={handleRemoveFromWishlist}  
              handleBuyNow={handleBuyNow} 
            />
          } 
        />

        {/* Cart */}
        <Route path="/cart" element={<CartPage />} />

        {/* --- ADDED CHECKOUT ROUTE HERE --- */}
        {/* We map /checkout to your PurchaseModal component */}
        <Route 
          path="/checkout" 
          element={isLoggedIn ? <PurchaseModal /> : <Navigate to="/auth" />} 
        />

      </Routes>
    </>
  );
};

export default AppRoutes;